// Feature: business-coverage-from-quote
// RTK thunk + plain actions backing the "Generate Business Coverage Summary
// from Quote" dialog. Mirrors the mirtapbxCallContext thunk pattern (shared
// `api` axios instance, `rejectWithValue` with an `APIError` payload) and the
// multipart quirk noted in the ifta import task: never set `Content-Type`
// manually so axios/the browser can emit the correct multipart boundary.

import { createAsyncThunk, createAction } from "@reduxjs/toolkit";
import { api } from "../../../api/api";
import { ERROR_MESSAGES } from "../../../constants/enums";
import { APIError } from "../../../constants/types";
import { showMessage } from "../../messages/messagesActions";
import { buildCoverageFromQuoteFormData } from "../../../helpers/coverageFromQuoteUpload";
import {
  CoverageFromQuoteSource,
  IGenerateCoverageFromQuoteArgs,
  IGenerateCoverageFromQuoteRaw,
} from "./coverageFromQuote.types";

export const generateCoverageFromQuoteAsync = createAsyncThunk<
  IGenerateCoverageFromQuoteRaw,
  IGenerateCoverageFromQuoteArgs,
  { rejectValue: APIError }
>(
  "coverageFromQuote/generate",
  async (args, { rejectWithValue, dispatch }) => {
    try {
      const fd = buildCoverageFromQuoteFormData(args);
      // Do NOT set Content-Type here — axios lets the browser emit
      // `multipart/form-data; boundary=...` automatically.
      const res = await api.post(
        "/policy/generate-business-coverage-from-quote",
        fd
      );
      dispatch(
        showMessage({
          type: "success",
          message: res.data.message,
          displayAs: "snackbar",
        })
      );
      return res.data.data as IGenerateCoverageFromQuoteRaw;
    } catch (err: any) {
      const message =
        err.response?.data?.message || ERROR_MESSAGES.SERVER_ERROR;
      dispatch(
        showMessage({
          type: "error",
          message,
          displayAs: "snackbar",
        })
      );
      return rejectWithValue({
        message,
        status: err.response?.status,
      });
    }
  }
);

export const resetCoverageFromQuote = createAction("coverageFromQuote/reset");

export const setCoverageFromQuoteSource =
  createAction<CoverageFromQuoteSource>("coverageFromQuote/setSource");
